import React from "react";
import { CPButton, CustomisedTertiaryButton, Wrapper } from "../../constants/common/StyledGlobalConstants";

import { useTranslation } from "react-i18next";
import { Modal } from "@vds/modals";
import styled from "styled-components";
import { connect } from "react-redux";
import RedesignedModal from "../common/RedesignedModal";
import PropTypes from "prop-types";
const TabletBreakPoint = 679;
const MobileBreakPoint = 480;

const TextWrapper = styled.p`
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "neue-haas-grotesk-text")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  padding: ${(props) => (props.padding ? props.padding : "")};
`;

export const StyledModalBox = styled(Modal)`
  min-height: ${(props) => props.mobHeight};
  height: ${(props) => props.mobHeight};
  max-height: ${(props) => props.mobMaxHeight};
  width: ${(props) => props.mobWidth};
  max-width: ${(props) => (props.mobMaxWidth ? props.mobMaxWidth : "initial")};
  box-shadow: 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 11px 15px -7px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: ${(props) => (props.padding ? props.padding : "24px 24px 24px 18px")};
  & h2 {
    font-family: "neue-haas-grotesk-display";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
  }
  & h4 {
    font-family: "neue-haas-grotesk-text";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    @media (max-width: 767px) {
      margin-top: 0 !important;
    }
  }
  .footer {
    display: flex;
    width: 100%;
    justify-content: end;
  }
  @media (max-width: 767px) {
    min-height: ${(props) => (props.userLang === "nl-NL" || props.userLang === "en-US" ? "12.25rem" : props.mobHeight)};
  }
`;

const DiscardModal = ({ open, onClose, yesButtonId, noButtonId, onYesButtonClick, windowSize, ...props }) => {
  const { t } = useTranslation("contractsTranslation");

  return (
      <RedesignedModal
        opened={open}
        onClickClose={onClose}
        zIndex={"1001"}
        title={t("Discard changes?")}
        ModalAriaLabel="Discard changes modal"
        button={
          <>
            <CustomisedTertiaryButton
              ariaLabel="Cancel"
              id={"continue-session"}
              onClick={onClose}
              buttonWidth={"100%"}
              buttonHeight={"40px"}
              fontSize={"14px"}
            >
              {t(`CANCEL`)}
            </CustomisedTertiaryButton>
            <CPButton
              width="autoTight"
              id={"Leave-button"}
              buttonHeight={"40px"}
              buttonWidth={"100%"}
              ariaLabel="Discard"
              boxButton={true}
              onClick={onYesButtonClick}
              style={{ height: "2.5rem" }}
              fontSize={"14px"}
            >
              {t(`DISCARD`)}
            </CPButton>
          </>
        }
      >
        <Wrapper fontFamily="neue-haas-grotesk-text" fontStyle="normal" fontWeight="400" fontSize="14px" marginBottom="0" marginTop="0">
          {t("Changes will not be saved.")}
        </Wrapper>
      </RedesignedModal>
  );
};

DiscardModal.defaultProps = {
  open: false,
  primaryButtonId: "",
  secondaryButtonId: "",
  windowSize: {},
};

DiscardModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  yesButtonId: PropTypes.string,
  noButtonId: PropTypes.string,
  onYesButtonClick: PropTypes.func,
  windowSize: PropTypes.object,
  primaryButtonId: PropTypes.string,
  secondaryButtonId: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    userLanguage: state.ACCOUNT.userLanguage,
  };
};

export default connect(mapStateToProps)(DiscardModal);